import { difference } from 'lodash'

import { DEFAULT_LOCALE } from './containers/app/constants'
import { messages as enTranslationMessages } from './zustand/language/chunks/en'

export const appLocales = [
  'bg',
  'hr',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'hu',
  'it',
  'nl',
  'no',
  'pl',
  'pt-br',
  'tr',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv'
]

// O Tolgee usa `pt-br` como tag do português, mas a API só aceita `pt`.
// O locale interno do app continua sendo o do Tolgee e a conversão acontece
// apenas na fronteira da API, através das duas funções abaixo.
const API_LANGUAGE_BY_APP_LOCALE = {
  'pt-br': 'pt'
}

const APP_LOCALE_BY_API_LANGUAGE = {
  pt: 'pt-br'
}

// Locale do app (`pt-br`) -> language aceito pela API (`pt`).
export const toApiLanguage = (locale) => {
  if (!locale) return locale

  const normalized = locale.toLowerCase()

  return API_LANGUAGE_BY_APP_LOCALE[normalized] ?? normalized
}

// Language da API (`pt`, `PT`) -> locale do app (`pt-br`).
export const toAppLocale = (language) => {
  if (!language) return language

  const normalized = language.toLowerCase()

  return APP_LOCALE_BY_API_LANGUAGE[normalized] ?? normalized
}

export const normalizeTranslationMessages = (messages) => {
  if (!messages || typeof messages !== 'object') {
    return {}
  }

  if (!messages.default || typeof messages.default !== 'object') {
    return messages
  }

  return Object.entries(messages).reduce(
    (normalizedMessages, [key, value]) => {
      if (key !== 'default') {
        normalizedMessages[key] = value
      }

      return normalizedMessages
    },
    { ...messages.default }
  )
}

const normalizedEnTranslationMessages = normalizeTranslationMessages(
  enTranslationMessages
)

export const formatTranslationMessages = (locale, messages) => {
  const normalizedMessages = normalizeTranslationMessages(messages)
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(
          DEFAULT_LOCALE,
          normalizedEnTranslationMessages
        )
      : {}

  return Object.keys(normalizedMessages).reduce((formattedMessages, key) => {
    let message = normalizedMessages[key]
    if (!message && locale !== DEFAULT_LOCALE) {
      message = defaultFormattedMessages[key]
    }

    // eslint-disable-next-line no-param-reassign
    formattedMessages[key] = message

    return formattedMessages
  }, {})
}

export const fillGaps = (formattedMessages) => {
  const diffKeys = difference(
    Object.keys(normalizedEnTranslationMessages),
    Object.keys(formattedMessages)
  )
  diffKeys.forEach((missingKey) => {
    // eslint-disable-next-line no-param-reassign
    formattedMessages[missingKey] = normalizedEnTranslationMessages[missingKey]
  })
  return formattedMessages
}
